import { useState } from "react";
import NotebookList from "./NotebookList";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import {storeNotebook} from "../../../../slice/notebookSlice";
import {handleClick} from "../../../../slice/clicksSlice";
import { storeNote } from "../../../../slice/noteSlice";
import LTSearchBox from "../../../common/LTSearchBox";
import { createLogger } from "../../../../utils/logger";

const logger = createLogger('NotebookPanel');

const NotebookPanel = ({ notebooks, onFilterNotebooks }) => {
  const [searchText, setSearchText] = useState("");
  const dispatch = useDispatch()


  const handleSearch = () => {
    onFilterNotebooks(searchText);
  };
  const navigate = useNavigate();

  const handleNotebookDetails = (notebook) => {
    logger.debug(`onSelectOneNotebook: ${notebook.id} `)
    dispatch(handleClick({name :'notebookId', id: notebook.id}));
    dispatch(storeNotebook(notebook));
    dispatch(storeNote(undefined))
    return navigate(`notebook/${notebook.id}`);
  };

  return (
    <>
      <div className="notebook-panel mt-1 mb-1 rounded-2 d-flex align-items-start flex-column mb-3">
        <div className="position-relative w-100">
<div className="d-flex border-bottom w-100 align-items-center p-2">
          <div className="flex-grow-1">
            <LTSearchBox
              value={searchText}
              placeholder="Search notebooks..."
              maxLength={30}
              onChange={setSearchText}
              onSearch={handleSearch}
              autoSearch={true}
              ariaLabel="Search notebooks"
            />
          </div>
        </div>
        </div>
        <div className="flex-grow-1 w-100 p-2 scroll-y">
          <NotebookList
            notebooks={notebooks}
            searchText={searchText}
            onSelectNotebook={(notebook) => {
              //console.log(notebook)
              handleNotebookDetails(notebook);
              //context.onNotebookSelected(notebook);
            }}
          ></NotebookList>
        </div>
      </div>
    </>
  );
};

export default NotebookPanel;
